import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useUniqueIds } from '../utilities/general'
import styles from './nav.module.scss'

const Nav = ({
  items,
  direction,
  alignment,
  mobile,
  className,
  activeClassName,
}) => {
  const itemsWithIds = useUniqueIds( items )

  return (
    <ul
      className={ classNames( styles.nav, {
        [ styles.horizontal ]: direction === 'horizontal',
        [ styles.vertical ]: direction === 'vertical',
        [ styles.alignStart ]: alignment === 'start',
        [ styles.alignCenter ]: alignment === 'center',
        [ styles.alignEnd ]: alignment === 'end',
        [ styles.alignAround ]: alignment === 'around',
        [ styles.alignBetween ]: alignment === 'between',
        [ styles.alignEvenly ]: alignment === 'even',
        [ styles.alignStretch ]: alignment === 'stretch',
        [ styles.noMobile ]: mobile === false
      }, className )}
    >
      { !! itemsWithIds.length && itemsWithIds.map( item => (
        <li key={ item.uniqueId } className={ styles.item }>
          { item.external ? (
            <a href={ item.to }>{ item.label }</a>
          ) : (
            <Link
              to={ item.to }
              partiallyActive={ item.partial }
              activeClassName={ classNames( styles.active, activeClassName ) }
            >
              { item.label }
            </Link>
          )}
        </li>
      ))}
    </ul>
  )
}

Nav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      external: PropTypes.bool,
      partial: PropTypes.bool,
    })
  ).isRequired,
  direction: PropTypes.string,
  alignment: PropTypes.string,
  mobile: PropTypes.bool,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
}

Nav.defaultProps = {
  direction: 'horizontal',
  alignment: 'start',
  mobile: true,
  className: '',
  activeClassName: '',
}

export default Nav
